import React from "react";
import "../../src/css/policy.css";
import LocationSlider from "./LocationSlider";

const Privacy_policy = () => {
  return (
    <>
      <div className="main-policy">
        <section className="policy-header">
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last Updated: January 2026</p>
        </section>

        <section className="policy-container">
          <p>
            Welcome to LaunchEStore (https://launchestore.com/). We are
            committed to protecting the privacy of our users (Business Owners)
            and their customers. This Privacy Policy explains how we collect,
            use, disclose, and safeguard your information when you use our
            platform, including our website, POS systems, and mobile
            applications.
          </p>

          <h2>1. Information We Collect</h2>
          <p>
            To provide a comprehensive business solution, we collect several
            types of information:
          </p>

          <h3>A. Business Owner Information (The Merchant)</h3>
          <ul>
            <li>
              <strong>Account Data:</strong> Name, email address, phone number,
              and business name.
            </li>
            <li>
              <strong>Business Operations:</strong> Inventory details, supplier
              information, purchase records, and sales invoices.
            </li>
            <li>
              <strong>Technical Data:</strong> Custom domain names, API keys for
              payment gateways, and integration credentials.
            </li>
            <li>
              <strong>Marketing Content:</strong> Images and text for festival
              posts and promotional materials.
            </li>
          </ul>

          <h3>B. End-Customer Information (The Buyer)</h3>
          <p>
            When a customer shops at a store powered by LaunchEStore, we collect
            information on behalf of the Merchant, including:
          </p>
          <ul>
            <li>Name, shipping address, and contact details.</li>
            <li>Order history and transaction details.</li>
            <li>Account login credentials for the specific business store.</li>
          </ul>

          <h2>2. How We Use Your Information</h2>
          <ul>
            <li>
              To enable the creation and management of custom websites and
              mobile apps.
            </li>
            <li>
              To process business transactions through POS and online checkout
              systems.
            </li>
            <li>
              To manage business logistics (inventory, suppliers, and
              invoicing).
            </li>
            <li>
              To provide technical support and ensure the security of the
              platform.
            </li>
          </ul>

          <h2>3. Data Storage and Security</h2>
          <ul>
            <li>
              <strong>Secured Cloud Infrastructure:</strong> All data is stored
              in secured, enterprise-grade cloud datacenters.
            </li>
            <li>
              <strong>Network Privacy:</strong> Business and customer data are
              stored on private networks and are not accessible via the public
              internet.
            </li>
            <li>
              <strong>Encryption:</strong> Industry-standard encryption is used
              to protect data during transit and at rest.
            </li>
          </ul>

          <h2>4. Data Sharing and Disclosure</h2>
          <ul>
            <li>
              We do not sell, rent, or trade business or customer data to third
              parties.
            </li>
            <li>
              Internal business data (suppliers, invoices, etc.) is never made
              public.
            </li>
            <li>
              Data is shared only with third-party services (such as payment
              gateways or shipping providers) that merchants explicitly connect
              to their accounts.
            </li>
            <li>
              Information may be disclosed if required by law or to protect our
              legal rights.
            </li>
          </ul>

          <h2>5. Merchant Responsibilities</h2>
          <p>
            Business Owners using LaunchEStore are responsible for the data of
            their customers and must provide their own privacy policy explaining
            how customer data is handled on their custom websites or apps.
          </p>

          <h2>6. Data Retention</h2>
          <p>
            We retain information as long as the account remains active. Upon
            subscription termination, data is deleted or anonymized in
            accordance with internal policies and legal requirements.
          </p>

          <h2>7. Your Rights</h2>
          <ul>
            <li>Access the personal data we hold about you.</li>
            <li>Request correction or deletion of your data.</li>
            <li>Withdraw consent for data processing, where applicable.</li>
          </ul>

          <h2>8. Changes to This Policy</h2>
          <p>
            This Privacy Policy may be updated from time to time. Any changes
            will be posted on this page along with an updated revision date.
          </p>

          <h2>9. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact
            us:
          </p>
          <p>
            Website:{" "}
            <a
              href="https://launchestore.com/contact"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://launchestore.com/contact
            </a>
          </p>
        </section>
      </div>

      <LocationSlider />
    </>
  );
};

export default Privacy_policy;
